import { globalStore } from "../components/Index"
import { actions, GEO_VAR_PARAM, VERS_PARAM } from "./redux-state"
import routes from "../routes"
import {
  activeStatePersistence,
  loadPersistedState,
} from "./redux-state-storage"
import { getJsonGroup } from "./json-provider"

export type IndicatorClass =
  | "GEM-GLO"
  | "GEM-EUR"
  | "GEM-AT"
  | "EWM-AT"
  | "EWM-EUR"
  | "EWM-GLO"
  | "CWM-GLO"

export function extractIndicatorClassFromPathname(
  pathName: string
): IndicatorClass {
  if (pathName.includes(routes.gemAt)) {
    return "GEM-AT"
  } else if (pathName.includes(routes.gemEur)) {
    return "GEM-EUR"
  } else if (pathName.includes(routes.cwmGlo)) {
    return "CWM-GLO"
  } else if (pathName.includes(routes.ewmAt)) {
    return "EWM-AT"
  } else if (pathName.includes(routes.ewmEur)) {
    return "EWM-EUR"
  } else if (pathName.includes(routes.ewmGlo)) {
    return "EWM-GLO"
  } else {
    return "GEM-GLO"
  }
}

export function switchIndicatorClass(newIndicatorClass: IndicatorClass) {
  const persistedState = loadPersistedState(newIndicatorClass)
  if (persistedState) {
    console.log("found persisted Redux state", newIndicatorClass)
    globalStore.dispatch(actions.restorePersistedState(persistedState))
  } else {
    console.log("did not find a persisted state", newIndicatorClass)
    globalStore.dispatch(actions.setIndicatorClass(newIndicatorClass))
  }
  activeStatePersistence()

  applyGeoVarFromUrl(newIndicatorClass)
}

function applyGeoVarFromUrl(indicatorClass: IndicatorClass) {
  const urlParams = new URLSearchParams(window.location.search)
  const geoVarFromUrlRaw: string | null = urlParams.get(GEO_VAR_PARAM)
  const versFromUrl: string | null = urlParams.get(VERS_PARAM)
  if (!geoVarFromUrlRaw) {
    return
  }
  const geoVarFromUrl = geoVarFromUrlRaw.replace(/-/g, " ")
  const geoVarGroup = getJsonGroup(indicatorClass)
  for (const geoVar of Object.keys(geoVarGroup)) {
    const geoVarName = geoVarGroup[geoVar]
    if (geoVarName.replace(/-/g, " ") === geoVarFromUrl) {
      console.log("apply geoVarFromUrl: " + geoVarFromUrl)

      // Apply version replacement if vers parameter is provided
      let finalGeoVar = geoVar
      if (versFromUrl) {
        finalGeoVar = geoVar.replace("_public.json", `_${versFromUrl}.json`)
        console.log("apply versFromUrl: " + versFromUrl + " -> " + finalGeoVar)
      }

      globalStore.dispatch(actions.setGeoVariable(finalGeoVar))
      return
    }
  }
  console.error(
    "geoVarFromUrl could not be resolved to the given indicatorClass:",
    geoVarFromUrl
  )
}
